import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import Icon from '@chama/ui-components/components/Icon';
import variables from '@chama/statics/stylesheets/variables';

import PriceInput from '../Inputs/ProductsFormPriceInput';

import './ProductsTable.css';

function handleDeleteConfirmation({ brand, intl, onDeleteDealerProduct }) {
  const message = intl.formatMessage({ id: 'remove_product_confirmation' });
  if (window.confirm(message)) onDeleteDealerProduct(brand);
}

function renderRows(props) {
  const {
    products,
    isEditing,
    errors,
    dealerCanDeleteProducts,
    onDeleteDealerProduct,
    intl,
  } = props;

  const makeDeleteButton = brand => {
    const action = () =>
      handleDeleteConfirmation({
        brand,
        onDeleteDealerProduct,
        intl,
      });

    return (
      dealerCanDeleteProducts &&
      isEditing && <Icon type="trash" iconColor={variables.default['--coral']} onClick={action} />
    );
  };

  return (
    products &&
    products.map(product => {
      return (
        <div key={`ProductsTable__row_${product.brand}`} className="ProductsTable__row">
          <div className="ProductsTable__cell">{product.brand}</div>
          <div className="ProductsTable__cell">{product.type}</div>
          <div className="ProductsTable__cell">
            <PriceInput
              name={product.brand}
              disabled={!isEditing}
              errored={product.brand in errors}
            />
          </div>
          <div className="ProductsTable__cell">{makeDeleteButton(product.brand)}</div>
        </div>
      );
    })
  );
}

function renderHeader() {
  return (
    <div className="ProductsTable__header">
      <div className="ProductsTable__cell">
        <FormattedMessage id="brand" />
      </div>
      <div className="ProductsTable__cell">
        <FormattedMessage id="type" />
      </div>
      <div className="ProductsTable__cell">
        <FormattedMessage id="price" />
      </div>
      <div className="ProductsTable__cell" />
    </div>
  );
}

function ProductsTable(props) {
  return (
    <div className="ProductsTable">
      {renderHeader()}
      {renderRows(props)}
    </div>
  );
}

export default injectIntl(ProductsTable);



// WEBPACK FOOTER //
// ../ui-components/components/DealerProducts/ProductsTable/ProductsTable.jsx